(function () {
  const initDragButtonCursor = (section) => {
    if (!section || !section.classList.contains('section-icon-features')) {
      return;
    }

    // Only works on tablet (750-1199px), NOT on desktop or mobile
    if (window.innerWidth >= 1200 || window.innerWidth < 750) {
      return;
    }

    // Only on devices with fine pointer (mouse/trackpad)
    if (!window.matchMedia('(pointer:fine)').matches) {
      return;
    }

    let isBtnCursorInit = false;
    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    const easingFactor = 0.175;
    let isAnimating = false;

    const button = section.querySelector('.icon-features-drag-button');
    const slider = section.querySelector('.icon-features__swiper');
    const container = section.querySelector('.swiper-wrapper');

    if (!container || !button || !slider) return;

    const animateButton = () => {
      isAnimating = true;

      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;

      button.style.left = `${currentX}px`;
      button.style.top = `${currentY}px`;

      if (
        Math.abs(targetX - currentX) > 0.1 ||
        Math.abs(targetY - currentY) > 0.1
      ) {
        requestAnimationFrame(() => animateButton());
      } else {
        isAnimating = false;
      }
    };

    const handleMouseMove = (e) => {
      slider.classList.add('cursor-active');

      const buttonRect = button.getBoundingClientRect();

      targetX = e.clientX - buttonRect.width / 2;
      targetY = e.clientY - buttonRect.height / 2;

      if (!isAnimating) {
        animateButton();
      }
    };

    const handleMouseEnter = (e) => {
      const buttonRect = button.getBoundingClientRect();

      targetX = currentX = e.clientX - buttonRect.width / 2;
      targetY = currentY = e.clientY - buttonRect.height / 2;

      button.style.left = `${currentX}px`;
      button.style.top = `${currentY}px`;

      slider.classList.add('cursor-active');
    };

    const handlePointerDown = () => {
      button.classList.add('drag-active');
    };

    const handlePointerUp = () => {
      button.classList.remove('drag-active');
    };

    const handleMouseLeave = () => {
      slider.classList.remove('cursor-active');
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('pointermove', handleMouseMove);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);
    container.addEventListener('pointerdown', handlePointerDown);
    container.addEventListener('pointerup', handlePointerUp);
  };

  // Initialize slider (only on mobile/tablet, NOT desktop)
  const initSlider = (section) => {
    if (!section || !section.classList.contains('section-icon-features')) {
      return;
    }

    // Don't initialize slider on desktop (1200px+)
    if (window.innerWidth >= 1200) {
      return;
    }

    const swiperEl = section.querySelector('.icon-features__swiper');
    if (!swiperEl || swiperEl.swiper) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (!slides || slides.length <= 1) return;

    const scrollbar = section.querySelector('.swiper-scrollbar');

    // Slider settings for mobile/tablet only
    const sliderSettings = {
      speed: 1000,
      allowTouchMove: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      slidesPerView: 1,
      spaceBetween: 8,
      watchSlidesProgress: true,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetAfter: 20,
          slidesOffsetBefore: 20,
        },
      },
    };

    new Swiper(swiperEl, sliderSettings);
  };

  const destroySlider = (section) => {
    const swiperEl = section.querySelector('.icon-features__swiper');
    if (!swiperEl?.swiper) return;
    swiperEl.swiper.destroy();
  };

  const initIconFeatures = (section) => {
    if (!section || !section.classList.contains('section-icon-features')) {
      return;
    }

    initSlider(section);
    
    // Only init drag cursor on mobile/tablet
    if (window.innerWidth < 1200) {
      initDragButtonCursor(section);
    }
  };

  // Handle resize - destroy/init slider as needed
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const section = document.querySelector('.section-icon-features');
      if (!section) return;

      if (window.innerWidth >= 1200) {
        // Desktop - destroy slider if it exists
        destroySlider(section);
      } else {
        // Mobile/Tablet - init slider if it doesn't exist
        const swiperEl = section.querySelector('.icon-features__swiper');
        if (swiperEl && !swiperEl.swiper) {
          initSlider(section);
          initDragButtonCursor(section);
        }
      }
    }, 250);
  });

  // Initialize on page load
  initIconFeatures(document.currentScript.parentElement);

  // Re-initialize on section reload (theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-icon-features')) {
      destroySlider(event.target);
      initIconFeatures(event.target);
    }
  });
})();